import type { PrintShopDefinition } from "@/types/domain"

export const demoPrintShops: PrintShopDefinition[] = [
  {
    id: "print-shop-atlas",
    name: "Gráfica Atlas",
    address: "",
    city: "",
    state: "",
    email: "",
    phone: "",
    whatsapp: "",
    attendant: "",
    contact: "",
  },
  {
    id: "print-shop-horizonte",
    name: "Impressos Horizonte",
    address: "",
    city: "",
    state: "",
    email: "",
    phone: "",
    whatsapp: "",
    attendant: "",
    contact: "",
  },
]
